/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VatViewModel
 */
export interface VatViewModel {
    /**
     * 
     * @type {number}
     * @memberof VatViewModel
     */
    vatRate: number;
}

/**
 * Check if a given object implements the VatViewModel interface.
 */
export function instanceOfVatViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "vatRate" in value;

    return isInstance;
}

export function VatViewModelFromJSON(json: any): VatViewModel {
    return VatViewModelFromJSONTyped(json, false);
}

export function VatViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): VatViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vatRate': json['VatRate'],
    };
}

export function VatViewModelToJSON(value?: VatViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'VatRate': value.vatRate,
    };
}

